<div class="p-2" [ngClass]="{ 'wide-screen': ( isWideScreen$ | async ) }">
  <router-outlet></router-outlet>
  <span class="package-version">Build: {{ packageVersion }}</span>
</div>